import { render, staticRenderFns } from "./elevatoralarm.vue?vue&type=template&id=077a72dc&"
import script from "./elevatoralarm.vue?vue&type=script&lang=js&"
export * from "./elevatoralarm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports